export const translations = {
  it: {
    nav: {
      home: "Home",
      industries: "Industries",
      products: "Prodotti",
      services: "Servizi",
      company: "Company",
      contact: "Contatti",
      privacy: "Privacy",
      cookies: "Cookie Policy"
    },
    hero: {
      subtitle: "Smart Digital Technology LAB",
      title1: "Creativity",
      title2: "drives innovation",
      description: "Utilizziamo tecnologie all'avanguardia per portare valore in diversi settori, aprendo la strada alla sicurezza e all'efficienza. Il nostro focus è sulla salute e sicurezza delle persone.",
      cta1: "Scopri i nostri prodotti",
      cta2: "Contattaci"
    },
    industries: {
      subtitle: "I nostri settori",
      title: "Industries",
      description: "SDTLab utilizza tecnologie all'avanguardia per portare valore in diversi settori, aprendo la strada alla sicurezza e all'efficienza.",
      items: [
        {
          title: "Industria",
          description: "Ottimizzazione dei processi produttivi e monitoraggio in tempo reale"
        },
        {
          title: "Sanità",
          description: "Soluzioni per la sicurezza dei pazienti e del personale sanitario"
        },
        {
          title: "Smart Cities",
          description: "Gestione intelligente degli spazi urbani e della mobilità"
        },
        {
          title: "Pubblica Amministrazione",
          description: "Servizi digitali per la sicurezza e l'efficienza operativa"
        }
      ]
    },
    products: {
      subtitle: "Le nostre soluzioni",
      title: "Products",
      owl: {
        tag: "Computer Vision",
        title: "OWL",
        description: "OWL è una soluzione completa di computer vision progettata per analizzare flussi video e gestire una varietà di scenari con precisione ed efficienza. Sfrutta l'IA avanzata per monitorare ambienti, migliorare la sicurezza e ottimizzare i processi decisionali.",
        features: [
          "Analisi video in tempo reale",
          "Monitoraggio sicurezza avanzato",
          "Intelligenza Artificiale integrata"
        ],
        cta: "Scopri OWL"
      },
      icornet: {
        tag: "AI Intelligence",
        tagNew: "Nuovo",
        title: "ICorNet",
        description: "ICorNet è la nostra piattaforma di ultima generazione dove l'innovazione incontra l'intelligence. Soluzione avanzata per l'analisi predittiva e il decision making basato su dati, progettata per trasformare informazioni complesse in azioni concrete.",
        features: [
          "Analisi predittiva avanzata",
          "Algoritmi AI proprietari",
          "Elaborazione edge computing"
        ],
        cta: "Scopri ICorNet"
      }
    },
    services: {
      subtitle: "Cosa facciamo",
      title: "Servizi",
      description: "Offriamo servizi specializzati grazie alle nostre competenze nello sviluppo, nell'uso dell'IA e delle nuove tecnologie.",
      study: {
        title: "Studio & Pianificazione",
        items: [
          "Analisi di settore e ricerca",
          "Studi di fattibilità e valutazione d'impatto",
          "Analisi dei bisogni per settore pubblico e privato",
          "Supporto per opportunità di finanza agevolata",
          "Supporto nella partecipazione a bandi nazionali ed europei"
        ]
      },
      analysis: {
        title: "Analisi & Sviluppo",
        items: [
          "Monitoraggio dati in tempo reale",
          "Creazione algoritmi AI specifici",
          "Sviluppo piattaforme ad hoc",
          "Analisi dati diversificati",
          "Valutazioni impatto ambientale e socio-economico"
        ]
      }
    },
    company: {
      subtitle: "Chi siamo",
      title: "Company",
      description1: "SDTLab s.r.l. nasce dalla più che ventennale esperienza di ingegneri e sviluppatori con un solido background nel mondo ICT e accademico.",
      description2: "Abbiamo combinato competenze tecniche avanzate, una visione strategica e una profonda connessione con il mondo della ricerca per offrire soluzioni innovative a esigenze reali e complesse.",
      description3: "Attraverso l'adozione di tecnologie all'avanguardia come edge computing e intelligenza artificiale, sviluppiamo strumenti capaci di catturare, elaborare e interpretare dati in tempo reale, trasformandoli in azioni concrete e decisioni intelligenti.",
      quote: "In SDTLab non ci limitiamo a innovare: puntiamo a contribuire a un futuro migliore, un dato alla volta.",
      experience: "Anni di esperienza"
    },
    leadership: {
      subtitle: "Il nostro team",
      title: "Leadership",
      ceo: {
        name: "Maria Rosaria Saporito",
        role: "CEO",
        description: "Con ampia esperienza in ricerca e sviluppo, Maria Rosaria guida le nostre iniziative strategiche con una visione per l'innovazione e la crescita."
      },
      cto: {
        name: "Stefano Tonetto",
        role: "CTO",
        description: "Stefano è responsabile delle attività di sviluppo e soluzioni innovative. Porta eccellenza tecnica e problem solving creativo al nostro team."
      }
    },
    contact: {
      subtitle: "Parliamo",
      title: "Contattaci",
      description: "Sei interessato alle nostre soluzioni? Contattaci per scoprire come possiamo aiutarti a trasformare i tuoi dati in valore.",
      address: "Indirizzo",
      phone: "Telefono",
      email: "Email",
      form: {
        name: "Nome",
        email: "Email",
        subject: "Oggetto",
        message: "Messaggio",
        submit: "Invia messaggio",
        success: "Messaggio inviato con successo!",
        error: "Errore nell'invio del messaggio"
      }
    },
    cookies: {
      title: "Utilizziamo i Cookie",
      description: "Questo sito utilizza cookie tecnici necessari al funzionamento e cookie analitici per migliorare la tua esperienza. Puoi accettare tutti i cookie o personalizzare le tue preferenze.",
      link: "Cookie Policy",
      acceptAll: "Accetta tutti",
      necessary: "Solo necessari",
      customize: "Personalizza"
    },
    privacy: {
      title: "Privacy Policy",
      lastUpdate: "Ultimo aggiornamento",
      sections: [
        {
          title: "1. Titolare del Trattamento",
          content: "Il Titolare del trattamento dei dati personali è SDTLab s.r.l., con sede legale in Via Guglielmo Marconi 141/143, 65126 Pescara (PE), P.IVA/C.F.: 02404780682, email: info@sdtlab.it"
        },
        {
          title: "2. Tipologie di Dati Raccolti",
          content: "I dati personali raccolti includono: dati di navigazione (indirizzi IP, orari di accesso), dati forniti volontariamente dall'utente (nome, email, telefono) tramite form di contatto, cookie tecnici e analitici."
        },
        {
          title: "3. Finalità del Trattamento",
          content: "I dati sono trattati per: erogazione dei servizi richiesti, risposta alle richieste di contatto, miglioramento dell'esperienza di navigazione, analisi statistiche anonime, adempimento di obblighi legali."
        },
        {
          title: "4. Base Giuridica",
          content: "Il trattamento si basa su: consenso dell'interessato, esecuzione di un contratto, legittimo interesse del Titolare, adempimento di obblighi legali."
        },
        {
          title: "5. Conservazione dei Dati",
          content: "I dati personali saranno conservati per il tempo necessario al raggiungimento delle finalità per cui sono stati raccolti e comunque non oltre i termini di legge."
        },
        {
          title: "6. Diritti dell'Interessato",
          content: "L'interessato ha diritto di: accedere ai propri dati, rettificarli, cancellarli, limitarne il trattamento, opporsi al trattamento, richiedere la portabilità dei dati."
        },
        {
          title: "7. Contatti",
          content: "Per esercitare i propri diritti o per qualsiasi informazione relativa al trattamento dei dati personali, è possibile contattare il Titolare all'indirizzo email: info@sdtlab.it"
        }
      ]
    },
    cookiePolicy: {
      title: "Cookie Policy",
      lastUpdate: "Ultimo aggiornamento",
      intro: "Questa Cookie Policy descrive cosa sono i cookie, come li utilizziamo sul nostro sito web e come gestire le tue preferenze.",
      sections: [
        {
          title: "1. Cosa sono i Cookie",
          content: "I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web. Permettono al sito di ricordare le tue azioni e preferenze."
        },
        {
          title: "2. Cookie Tecnici (Necessari)",
          content: "Questi cookie sono essenziali per il funzionamento del sito web. Includono cookie di sessione e cookie per la gestione delle preferenze sui cookie. Non richiedono consenso."
        },
        {
          title: "3. Cookie Analitici",
          content: "Utilizziamo cookie analitici per comprendere come i visitatori interagiscono con il nostro sito. Questi dati ci aiutano a migliorare l'esperienza utente. Vengono attivati solo con il tuo consenso."
        },
        {
          title: "4. Gestione dei Cookie",
          content: "Puoi gestire le tue preferenze sui cookie attraverso il banner che appare alla prima visita o modificando le impostazioni del tuo browser. Nota che disabilitare alcuni cookie potrebbe influire sulla funzionalità del sito."
        },
        {
          title: "5. Cookie di Terze Parti",
          content: "Il nostro sito potrebbe includere servizi di terze parti che utilizzano propri cookie. Ti invitiamo a consultare le rispettive privacy policy."
        }
      ]
    },
    footer: {
      rights: "Tutti i diritti riservati",
      vat: "P.I./C.F."
    }
  },
  en: {
    nav: {
      home: "Home",
      industries: "Industries",
      products: "Products",
      services: "Services",
      company: "Company",
      contact: "Contact",
      privacy: "Privacy",
      cookies: "Cookie Policy"
    },
    hero: {
      subtitle: "Smart Digital Technology LAB",
      title1: "Creativity",
      title2: "drives innovation",
      description: "We use cutting-edge technologies to bring value to different sectors, paving the way for security and efficiency. Our focus is on the health and safety of people.",
      cta1: "Discover our products",
      cta2: "Contact us"
    },
    industries: {
      subtitle: "Our sectors",
      title: "Industries",
      description: "SDTLab uses cutting-edge technologies to bring value to different sectors, paving the way for security and efficiency.",
      items: [
        {
          title: "Industry",
          description: "Production process optimization and real-time monitoring"
        },
        {
          title: "Healthcare",
          description: "Solutions for patient and healthcare staff safety"
        },
        {
          title: "Smart Cities",
          description: "Intelligent management of urban spaces and mobility"
        },
        {
          title: "Public Administration",
          description: "Digital services for security and operational efficiency"
        }
      ]
    },
    products: {
      subtitle: "Our solutions",
      title: "Products",
      owl: {
        tag: "Computer Vision",
        title: "OWL",
        description: "OWL is a comprehensive computer vision solution designed to analyze video streams and manage a variety of scenarios with precision and efficiency. It leverages advanced AI to monitor environments, enhance security, and optimize decision-making processes.",
        features: [
          "Real-time video analysis",
          "Advanced security monitoring",
          "Integrated Artificial Intelligence"
        ],
        cta: "Discover OWL"
      },
      icornet: {
        tag: "AI Intelligence",
        tagNew: "New",
        title: "ICorNet",
        description: "ICorNet is our next-generation platform where innovation meets intelligence. An advanced solution for predictive analysis and data-driven decision making, designed to transform complex information into concrete actions.",
        features: [
          "Advanced predictive analysis",
          "Proprietary AI algorithms",
          "Edge computing processing"
        ],
        cta: "Discover ICorNet"
      }
    },
    services: {
      subtitle: "What we do",
      title: "Services",
      description: "We offer specialized services thanks to our expertise in development, AI use, and new technologies.",
      study: {
        title: "Study & Planning",
        items: [
          "Sector analysis and research",
          "Feasibility studies and impact assessment",
          "Needs analysis for public and private sectors",
          "Support for subsidized finance opportunities",
          "Support in participating in national and European calls"
        ]
      },
      analysis: {
        title: "Analysis & Development",
        items: [
          "Real-time data monitoring",
          "Creation of specific AI algorithms",
          "Development of ad hoc platforms",
          "Diversified data analysis",
          "Environmental and socio-economic impact assessments"
        ]
      }
    },
    company: {
      subtitle: "About us",
      title: "Company",
      description1: "SDTLab s.r.l. was born from the more than twenty-year experience of engineers and developers with a solid background in the ICT and academic world.",
      description2: "We've combined advanced technical skills, a strategic vision, and a deep connection with the world of research to offer innovative solutions to real and complex needs.",
      description3: "Through the adoption of cutting-edge technologies such as edge computing and artificial intelligence, we develop tools that can capture, process, and interpret data in real time, turning them into concrete actions and intelligent decisions.",
      quote: "At SDTLab, we don't just innovate: we aim to contribute to a better future, one data at a time.",
      experience: "Years of experience"
    },
    leadership: {
      subtitle: "Our team",
      title: "Leadership",
      ceo: {
        name: "Maria Rosaria Saporito",
        role: "CEO",
        description: "With extensive experience in research and development, Maria Rosaria leads our strategic initiatives with a vision for innovation and growth."
      },
      cto: {
        name: "Stefano Tonetto",
        role: "CTO",
        description: "Stefano is responsible for development activities and innovative solutions. He brings technical excellence and creative problem solving to our team."
      }
    },
    contact: {
      subtitle: "Let's talk",
      title: "Contact Us",
      description: "Interested in our solutions? Contact us to discover how we can help you transform your data into value.",
      address: "Address",
      phone: "Phone",
      email: "Email",
      form: {
        name: "Name",
        email: "Email",
        subject: "Subject",
        message: "Message",
        submit: "Send message",
        success: "Message sent successfully!",
        error: "Error sending message"
      }
    },
    cookies: {
      title: "We Use Cookies",
      description: "This site uses technical cookies necessary for operation and analytical cookies to improve your experience. You can accept all cookies or customize your preferences.",
      link: "Cookie Policy",
      acceptAll: "Accept all",
      necessary: "Only necessary",
      customize: "Customize"
    },
    privacy: {
      title: "Privacy Policy",
      lastUpdate: "Last update",
      sections: [
        {
          title: "1. Data Controller",
          content: "The Data Controller is SDTLab s.r.l., with registered office at Via Guglielmo Marconi 141/143, 65126 Pescara (PE), VAT/Tax Code: 02404780682, email: info@sdtlab.it"
        },
        {
          title: "2. Types of Data Collected",
          content: "Personal data collected includes: navigation data (IP addresses, access times), data voluntarily provided by the user (name, email, phone) through contact forms, technical and analytical cookies."
        },
        {
          title: "3. Purposes of Processing",
          content: "Data is processed for: providing requested services, responding to contact requests, improving navigation experience, anonymous statistical analysis, compliance with legal obligations."
        },
        {
          title: "4. Legal Basis",
          content: "Processing is based on: consent of the interested party, execution of a contract, legitimate interest of the Controller, compliance with legal obligations."
        },
        {
          title: "5. Data Retention",
          content: "Personal data will be kept for the time necessary to achieve the purposes for which they were collected and in any case not beyond the legal terms."
        },
        {
          title: "6. Rights of the Data Subject",
          content: "The interested party has the right to: access their data, rectify them, delete them, limit processing, object to processing, request data portability."
        },
        {
          title: "7. Contacts",
          content: "To exercise your rights or for any information regarding the processing of personal data, you can contact the Controller at the email address: info@sdtlab.it"
        }
      ]
    },
    cookiePolicy: {
      title: "Cookie Policy",
      lastUpdate: "Last update",
      intro: "This Cookie Policy describes what cookies are, how we use them on our website, and how to manage your preferences.",
      sections: [
        {
          title: "1. What are Cookies",
          content: "Cookies are small text files that are stored on your device when you visit a website. They allow the site to remember your actions and preferences."
        },
        {
          title: "2. Technical Cookies (Necessary)",
          content: "These cookies are essential for the operation of the website. They include session cookies and cookies for managing cookie preferences. They do not require consent."
        },
        {
          title: "3. Analytical Cookies",
          content: "We use analytical cookies to understand how visitors interact with our site. This data helps us improve the user experience. They are only activated with your consent."
        },
        {
          title: "4. Cookie Management",
          content: "You can manage your cookie preferences through the banner that appears on your first visit or by changing your browser settings. Note that disabling some cookies may affect site functionality."
        },
        {
          title: "5. Third-Party Cookies",
          content: "Our site may include third-party services that use their own cookies. We invite you to consult their respective privacy policies."
        }
      ]
    },
    footer: {
      rights: "All rights reserved",
      vat: "VAT/Tax Code"
    }
  },
  de: {
    nav: {
      home: "Home",
      industries: "Branchen",
      products: "Produkte",
      services: "Dienstleistungen",
      company: "Unternehmen",
      contact: "Kontakt",
      privacy: "Datenschutz",
      cookies: "Cookie-Richtlinie"
    },
    hero: {
      subtitle: "Smart Digital Technology LAB",
      title1: "Creativity",
      title2: "drives innovation",
      description: "Wir nutzen modernste Technologien, um in verschiedenen Sektoren Mehrwert zu schaffen und den Weg für Sicherheit und Effizienz zu ebnen. Unser Fokus liegt auf der Gesundheit und Sicherheit der Menschen.",
      cta1: "Entdecken Sie unsere Produkte",
      cta2: "Kontaktieren Sie uns"
    },
    industries: {
      subtitle: "Unsere Sektoren",
      title: "Branchen",
      description: "SDTLab nutzt modernste Technologien, um in verschiedenen Sektoren Mehrwert zu schaffen und den Weg für Sicherheit und Effizienz zu ebnen.",
      items: [
        {
          title: "Industrie",
          description: "Optimierung von Produktionsprozessen und Echtzeitüberwachung"
        },
        {
          title: "Gesundheitswesen",
          description: "Lösungen für die Sicherheit von Patienten und medizinischem Personal"
        },
        {
          title: "Smart Cities",
          description: "Intelligentes Management von städtischen Räumen und Mobilität"
        },
        {
          title: "Öffentliche Verwaltung",
          description: "Digitale Dienste für Sicherheit und betriebliche Effizienz"
        }
      ]
    },
    products: {
      subtitle: "Unsere Lösungen",
      title: "Produkte",
      owl: {
        tag: "Computer Vision",
        title: "OWL",
        description: "OWL ist eine umfassende Computer-Vision-Lösung, die entwickelt wurde, um Videoströme zu analysieren und eine Vielzahl von Szenarien mit Präzision und Effizienz zu verwalten. Es nutzt fortschrittliche KI, um Umgebungen zu überwachen, die Sicherheit zu verbessern und Entscheidungsprozesse zu optimieren.",
        features: [
          "Echtzeit-Videoanalyse",
          "Fortschrittliche Sicherheitsüberwachung",
          "Integrierte künstliche Intelligenz"
        ],
        cta: "OWL entdecken"
      },
      icornet: {
        tag: "KI-Intelligenz",
        tagNew: "Neu",
        title: "ICorNet",
        description: "ICorNet ist unsere Plattform der nächsten Generation, wo Innovation auf Intelligenz trifft. Eine fortschrittliche Lösung für prädiktive Analysen und datengestützte Entscheidungsfindung, die darauf ausgelegt ist, komplexe Informationen in konkrete Maßnahmen umzuwandeln.",
        features: [
          "Fortgeschrittene prädiktive Analyse",
          "Proprietäre KI-Algorithmen",
          "Edge-Computing-Verarbeitung"
        ],
        cta: "ICorNet entdecken"
      }
    },
    services: {
      subtitle: "Was wir tun",
      title: "Dienstleistungen",
      description: "Wir bieten spezialisierte Dienstleistungen dank unserer Expertise in Entwicklung, KI-Nutzung und neuen Technologien.",
      study: {
        title: "Studie & Planung",
        items: [
          "Branchenanalyse und Forschung",
          "Machbarkeitsstudien und Folgenabschätzung",
          "Bedarfsanalyse für öffentliche und private Sektoren",
          "Unterstützung bei geförderten Finanzierungsmöglichkeiten",
          "Unterstützung bei der Teilnahme an nationalen und europäischen Ausschreibungen"
        ]
      },
      analysis: {
        title: "Analyse & Entwicklung",
        items: [
          "Echtzeit-Datenüberwachung",
          "Erstellung spezifischer KI-Algorithmen",
          "Entwicklung maßgeschneiderter Plattformen",
          "Diversifizierte Datenanalyse",
          "Umwelt- und sozioökonomische Folgenabschätzungen"
        ]
      }
    },
    company: {
      subtitle: "Über uns",
      title: "Unternehmen",
      description1: "SDTLab s.r.l. entstand aus der mehr als zwanzigjährigen Erfahrung von Ingenieuren und Entwicklern mit solidem Hintergrund in der ICT- und akademischen Welt.",
      description2: "Wir haben fortgeschrittene technische Fähigkeiten, eine strategische Vision und eine tiefe Verbindung zur Forschungswelt kombiniert, um innovative Lösungen für reale und komplexe Bedürfnisse anzubieten.",
      description3: "Durch die Einführung modernster Technologien wie Edge Computing und künstlicher Intelligenz entwickeln wir Werkzeuge, die Daten in Echtzeit erfassen, verarbeiten und interpretieren und sie in konkrete Aktionen und intelligente Entscheidungen umwandeln können.",
      quote: "Bei SDTLab innovieren wir nicht nur: Wir wollen zu einer besseren Zukunft beitragen, ein Datum nach dem anderen.",
      experience: "Jahre Erfahrung"
    },
    leadership: {
      subtitle: "Unser Team",
      title: "Führung",
      ceo: {
        name: "Maria Rosaria Saporito",
        role: "CEO",
        description: "Mit umfangreicher Erfahrung in Forschung und Entwicklung leitet Maria Rosaria unsere strategischen Initiativen mit einer Vision für Innovation und Wachstum."
      },
      cto: {
        name: "Stefano Tonetto",
        role: "CTO",
        description: "Stefano ist verantwortlich für Entwicklungsaktivitäten und innovative Lösungen. Er bringt technische Exzellenz und kreative Problemlösung in unser Team."
      }
    },
    contact: {
      subtitle: "Sprechen wir",
      title: "Kontaktieren Sie uns",
      description: "Interessiert an unseren Lösungen? Kontaktieren Sie uns, um zu erfahren, wie wir Ihnen helfen können, Ihre Daten in Wert umzuwandeln.",
      address: "Adresse",
      phone: "Telefon",
      email: "E-Mail",
      form: {
        name: "Name",
        email: "E-Mail",
        subject: "Betreff",
        message: "Nachricht",
        submit: "Nachricht senden",
        success: "Nachricht erfolgreich gesendet!",
        error: "Fehler beim Senden der Nachricht"
      }
    },
    cookies: {
      title: "Wir verwenden Cookies",
      description: "Diese Website verwendet technische Cookies, die für den Betrieb erforderlich sind, und analytische Cookies, um Ihre Erfahrung zu verbessern. Sie können alle Cookies akzeptieren oder Ihre Präferenzen anpassen.",
      link: "Cookie-Richtlinie",
      acceptAll: "Alle akzeptieren",
      necessary: "Nur notwendige",
      customize: "Anpassen"
    },
    privacy: {
      title: "Datenschutzrichtlinie",
      lastUpdate: "Letzte Aktualisierung",
      sections: [
        {
          title: "1. Verantwortlicher für die Datenverarbeitung",
          content: "Der Verantwortliche für die Datenverarbeitung ist SDTLab s.r.l., mit Sitz in Via Guglielmo Marconi 141/143, 65126 Pescara (PE), USt-IdNr./Steuernummer: 02404780682, E-Mail: info@sdtlab.it"
        },
        {
          title: "2. Arten der erhobenen Daten",
          content: "Erhobene personenbezogene Daten umfassen: Navigationsdaten (IP-Adressen, Zugriffszeiten), vom Benutzer freiwillig bereitgestellte Daten (Name, E-Mail, Telefon) über Kontaktformulare, technische und analytische Cookies."
        },
        {
          title: "3. Zwecke der Verarbeitung",
          content: "Daten werden verarbeitet für: Bereitstellung angeforderter Dienste, Beantwortung von Kontaktanfragen, Verbesserung des Navigationserlebnisses, anonyme statistische Analysen, Einhaltung gesetzlicher Verpflichtungen."
        },
        {
          title: "4. Rechtsgrundlage",
          content: "Die Verarbeitung basiert auf: Einwilligung der betroffenen Person, Vertragserfüllung, berechtigtes Interesse des Verantwortlichen, Einhaltung gesetzlicher Verpflichtungen."
        },
        {
          title: "5. Datenspeicherung",
          content: "Personenbezogene Daten werden für die Zeit aufbewahrt, die erforderlich ist, um die Zwecke zu erreichen, für die sie erhoben wurden, und in jedem Fall nicht über die gesetzlichen Fristen hinaus."
        },
        {
          title: "6. Rechte der betroffenen Person",
          content: "Die betroffene Person hat das Recht: auf Zugang zu ihren Daten, auf Berichtigung, auf Löschung, auf Einschränkung der Verarbeitung, auf Widerspruch gegen die Verarbeitung, auf Datenübertragbarkeit."
        },
        {
          title: "7. Kontakt",
          content: "Um Ihre Rechte auszuüben oder für Informationen zur Verarbeitung personenbezogener Daten können Sie den Verantwortlichen unter der E-Mail-Adresse kontaktieren: info@sdtlab.it"
        }
      ]
    },
    cookiePolicy: {
      title: "Cookie-Richtlinie",
      lastUpdate: "Letzte Aktualisierung",
      intro: "Diese Cookie-Richtlinie beschreibt, was Cookies sind, wie wir sie auf unserer Website verwenden und wie Sie Ihre Präferenzen verwalten können.",
      sections: [
        {
          title: "1. Was sind Cookies",
          content: "Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden, wenn Sie eine Website besuchen. Sie ermöglichen es der Website, Ihre Aktionen und Präferenzen zu speichern."
        },
        {
          title: "2. Technische Cookies (Notwendig)",
          content: "Diese Cookies sind für den Betrieb der Website unerlässlich. Sie umfassen Sitzungscookies und Cookies zur Verwaltung von Cookie-Präferenzen. Sie erfordern keine Einwilligung."
        },
        {
          title: "3. Analytische Cookies",
          content: "Wir verwenden analytische Cookies, um zu verstehen, wie Besucher mit unserer Website interagieren. Diese Daten helfen uns, das Benutzererlebnis zu verbessern. Sie werden nur mit Ihrer Einwilligung aktiviert."
        },
        {
          title: "4. Cookie-Verwaltung",
          content: "Sie können Ihre Cookie-Präferenzen über das Banner verwalten, das bei Ihrem ersten Besuch erscheint, oder indem Sie Ihre Browsereinstellungen ändern. Beachten Sie, dass das Deaktivieren einiger Cookies die Funktionalität der Website beeinträchtigen kann."
        },
        {
          title: "5. Cookies von Drittanbietern",
          content: "Unsere Website kann Dienste von Drittanbietern enthalten, die ihre eigenen Cookies verwenden. Wir laden Sie ein, deren jeweilige Datenschutzrichtlinien zu konsultieren."
        }
      ]
    },
    footer: {
      rights: "Alle Rechte vorbehalten",
      vat: "USt-IdNr./Steuernummer"
    }
  },
  es: {
    nav: {
      home: "Inicio",
      industries: "Industrias",
      products: "Productos",
      services: "Servicios",
      company: "Empresa",
      contact: "Contacto",
      privacy: "Privacidad",
      cookies: "Política de Cookies"
    },
    hero: {
      subtitle: "Smart Digital Technology LAB",
      title1: "Creativity",
      title2: "drives innovation",
      description: "Utilizamos tecnologías de vanguardia para aportar valor a diferentes sectores, abriendo el camino hacia la seguridad y la eficiencia. Nuestro enfoque está en la salud y seguridad de las personas.",
      cta1: "Descubre nuestros productos",
      cta2: "Contáctanos"
    },
    industries: {
      subtitle: "Nuestros sectores",
      title: "Industrias",
      description: "SDTLab utiliza tecnologías de vanguardia para aportar valor a diferentes sectores, abriendo el camino hacia la seguridad y la eficiencia.",
      items: [
        {
          title: "Industria",
          description: "Optimización de procesos productivos y monitoreo en tiempo real"
        },
        {
          title: "Sanidad",
          description: "Soluciones para la seguridad de pacientes y personal sanitario"
        },
        {
          title: "Smart Cities",
          description: "Gestión inteligente de espacios urbanos y movilidad"
        },
        {
          title: "Administración Pública",
          description: "Servicios digitales para la seguridad y eficiencia operativa"
        }
      ]
    },
    products: {
      subtitle: "Nuestras soluciones",
      title: "Productos",
      owl: {
        tag: "Computer Vision",
        title: "OWL",
        description: "OWL es una solución completa de visión por computadora diseñada para analizar flujos de video y gestionar una variedad de escenarios con precisión y eficiencia. Aprovecha la IA avanzada para monitorear entornos, mejorar la seguridad y optimizar los procesos de toma de decisiones.",
        features: [
          "Análisis de video en tiempo real",
          "Monitoreo de seguridad avanzado",
          "Inteligencia Artificial integrada"
        ],
        cta: "Descubre OWL"
      },
      icornet: {
        tag: "Inteligencia AI",
        tagNew: "Nuevo",
        title: "ICorNet",
        description: "ICorNet es nuestra plataforma de última generación donde la innovación se encuentra con la inteligencia. Una solución avanzada para el análisis predictivo y la toma de decisiones basada en datos, diseñada para transformar información compleja en acciones concretas.",
        features: [
          "Análisis predictivo avanzado",
          "Algoritmos de IA propietarios",
          "Procesamiento edge computing"
        ],
        cta: "Descubre ICorNet"
      }
    },
    services: {
      subtitle: "Lo que hacemos",
      title: "Servicios",
      description: "Ofrecemos servicios especializados gracias a nuestra experiencia en desarrollo, uso de IA y nuevas tecnologías.",
      study: {
        title: "Estudio y Planificación",
        items: [
          "Análisis sectorial e investigación",
          "Estudios de viabilidad y evaluación de impacto",
          "Análisis de necesidades para sectores público y privado",
          "Apoyo para oportunidades de financiación subvencionada",
          "Apoyo en la participación en convocatorias nacionales y europeas"
        ]
      },
      analysis: {
        title: "Análisis y Desarrollo",
        items: [
          "Monitoreo de datos en tiempo real",
          "Creación de algoritmos de IA específicos",
          "Desarrollo de plataformas ad hoc",
          "Análisis de datos diversificados",
          "Evaluaciones de impacto ambiental y socioeconómico"
        ]
      }
    },
    company: {
      subtitle: "Sobre nosotros",
      title: "Empresa",
      description1: "SDTLab s.r.l. nació de la experiencia de más de veinte años de ingenieros y desarrolladores con una sólida formación en el mundo ICT y académico.",
      description2: "Hemos combinado habilidades técnicas avanzadas, una visión estratégica y una profunda conexión con el mundo de la investigación para ofrecer soluciones innovadoras a necesidades reales y complejas.",
      description3: "A través de la adopción de tecnologías de vanguardia como edge computing e inteligencia artificial, desarrollamos herramientas capaces de capturar, procesar e interpretar datos en tiempo real, convirtiéndolos en acciones concretas y decisiones inteligentes.",
      quote: "En SDTLab no solo innovamos: aspiramos a contribuir a un futuro mejor, un dato a la vez.",
      experience: "Años de experiencia"
    },
    leadership: {
      subtitle: "Nuestro equipo",
      title: "Liderazgo",
      ceo: {
        name: "Maria Rosaria Saporito",
        role: "CEO",
        description: "Con amplia experiencia en investigación y desarrollo, Maria Rosaria lidera nuestras iniciativas estratégicas con una visión de innovación y crecimiento."
      },
      cto: {
        name: "Stefano Tonetto",
        role: "CTO",
        description: "Stefano es responsable de las actividades de desarrollo y soluciones innovadoras. Aporta excelencia técnica y resolución creativa de problemas a nuestro equipo."
      }
    },
    contact: {
      subtitle: "Hablemos",
      title: "Contáctanos",
      description: "¿Interesado en nuestras soluciones? Contáctanos para descubrir cómo podemos ayudarte a transformar tus datos en valor.",
      address: "Dirección",
      phone: "Teléfono",
      email: "Email",
      form: {
        name: "Nombre",
        email: "Email",
        subject: "Asunto",
        message: "Mensaje",
        submit: "Enviar mensaje",
        success: "¡Mensaje enviado con éxito!",
        error: "Error al enviar el mensaje"
      }
    },
    cookies: {
      title: "Usamos Cookies",
      description: "Este sitio utiliza cookies técnicas necesarias para el funcionamiento y cookies analíticas para mejorar tu experiencia. Puedes aceptar todas las cookies o personalizar tus preferencias.",
      link: "Política de Cookies",
      acceptAll: "Aceptar todas",
      necessary: "Solo necesarias",
      customize: "Personalizar"
    },
    privacy: {
      title: "Política de Privacidad",
      lastUpdate: "Última actualización",
      sections: [
        {
          title: "1. Responsable del Tratamiento",
          content: "El Responsable del tratamiento de datos personales es SDTLab s.r.l., con domicilio social en Via Guglielmo Marconi 141/143, 65126 Pescara (PE), NIF: 02404780682, email: info@sdtlab.it"
        },
        {
          title: "2. Tipos de Datos Recogidos",
          content: "Los datos personales recogidos incluyen: datos de navegación (direcciones IP, horarios de acceso), datos proporcionados voluntariamente por el usuario (nombre, email, teléfono) a través de formularios de contacto, cookies técnicas y analíticas."
        },
        {
          title: "3. Finalidades del Tratamiento",
          content: "Los datos se tratan para: prestación de servicios solicitados, respuesta a solicitudes de contacto, mejora de la experiencia de navegación, análisis estadísticos anónimos, cumplimiento de obligaciones legales."
        },
        {
          title: "4. Base Jurídica",
          content: "El tratamiento se basa en: consentimiento del interesado, ejecución de un contrato, interés legítimo del Responsable, cumplimiento de obligaciones legales."
        },
        {
          title: "5. Conservación de los Datos",
          content: "Los datos personales se conservarán durante el tiempo necesario para alcanzar las finalidades para las que fueron recogidos y en todo caso no más allá de los plazos legales."
        },
        {
          title: "6. Derechos del Interesado",
          content: "El interesado tiene derecho a: acceder a sus datos, rectificarlos, suprimirlos, limitar el tratamiento, oponerse al tratamiento, solicitar la portabilidad de los datos."
        },
        {
          title: "7. Contactos",
          content: "Para ejercer sus derechos o para cualquier información relativa al tratamiento de datos personales, puede contactar al Responsable en la dirección de email: info@sdtlab.it"
        }
      ]
    },
    cookiePolicy: {
      title: "Política de Cookies",
      lastUpdate: "Última actualización",
      intro: "Esta Política de Cookies describe qué son las cookies, cómo las usamos en nuestro sitio web y cómo gestionar tus preferencias.",
      sections: [
        {
          title: "1. Qué son las Cookies",
          content: "Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Permiten al sitio recordar tus acciones y preferencias."
        },
        {
          title: "2. Cookies Técnicas (Necesarias)",
          content: "Estas cookies son esenciales para el funcionamiento del sitio web. Incluyen cookies de sesión y cookies para la gestión de preferencias de cookies. No requieren consentimiento."
        },
        {
          title: "3. Cookies Analíticas",
          content: "Usamos cookies analíticas para entender cómo los visitantes interactúan con nuestro sitio. Estos datos nos ayudan a mejorar la experiencia del usuario. Solo se activan con tu consentimiento."
        },
        {
          title: "4. Gestión de Cookies",
          content: "Puedes gestionar tus preferencias de cookies a través del banner que aparece en tu primera visita o cambiando la configuración de tu navegador. Ten en cuenta que deshabilitar algunas cookies puede afectar la funcionalidad del sitio."
        },
        {
          title: "5. Cookies de Terceros",
          content: "Nuestro sitio puede incluir servicios de terceros que utilizan sus propias cookies. Te invitamos a consultar sus respectivas políticas de privacidad."
        }
      ]
    },
    footer: {
      rights: "Todos los derechos reservados",
      vat: "NIF"
    }
  }
};

export const languages = [
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];